module.exports = __webpack_public_path__ + "static/media/default-bigwinning-icon.7ae834c2.svg";